function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import styled from "styled-components";
import { SelectableWrapper } from "sprout-ui-dom/dist/Selectables";
import { Flex, Text } from "sprout-ui-primitives";
import { LocalOfferTwoTone } from "sprout-ui-icons";
import { themeGet } from "sprout-ui-theme";
import { colorMap } from "@sprout/client-lib/dist/labels_next";
const StyledLocalOfferTwoTone = styled(LocalOfferTwoTone)`
  path:nth-child(2) {
    fill: ${({ $color  })=>$color};
    stroke: ${themeGet("colors.white.100")};
    stroke-width: 1;
  }
`;
const LabelEditColorDialogLabels = (props)=>{
    const { colors , getItemProps  } = props;
    if (colors.length === 0) return /*#__PURE__*/ _jsx(Text, {
        mx: 1,
        children: "No matches found"
    });
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: colors.map((color, index)=>/*#__PURE__*/ _jsxs(SelectableWrapper, _objectSpread({}, getItemProps({
                index,
                item: color
            }), {
                children: [
                    /*#__PURE__*/ _jsx(Flex, {
                        as: "span",
                        color: "white.100",
                        children: /*#__PURE__*/ _jsx(StyledLocalOfferTwoTone, {
                            $color: colorMap[color]
                        })
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "span",
                        fontSize: "15px",
                        fontWeight: "medium",
                        ml: 1,
                        children: color
                    })
                ]
            }), color))
    });
};
export default LabelEditColorDialogLabels;
